// Shared by the server and browser. Never send game payloads or identity data.
export function safeUrl(value) {
  if (!value) return value;
  try {
    const url = new URL(value, "https://playmajlis.invalid");
    url.username = "";
    url.password = "";
    url.search = "";
    url.hash = "";
    url.pathname = url.pathname
      .replace(/^\/(?:game\/)?play\/[^/]+\/?$/, "/play/:roomCode")
      .replace(/^\/(?!host\/?$|play\/?$)[A-Za-z0-9]{4}\/?$/, "/:roomCode")
      .replace(/\/(?:user_[^/]+|\d+)(?=\/|$)/g, "/:id");
    return /^[a-z]+:\/\//i.test(value) ? url.toString() : url.pathname;
  } catch { return "[invalid URL]"; }
}

export function sanitizeEvent(event) {
  delete event.user;
  delete event.extra;
  delete event.breadcrumbs;
  delete event.message;
  delete event.logentry;
  delete event.server_name;
  // Exception text can contain answers, SQL parameters, or payment responses.
  // Keep the type and stack for grouping/debugging, never arbitrary messages.
  for (const exception of event.exception?.values || []) {
    exception.value = "Error details withheld for player privacy";
    if (exception.mechanism) delete exception.mechanism.data;
    for (const frame of exception.stacktrace?.frames || []) {
      delete frame.vars;
      delete frame.pre_context;
      delete frame.post_context;
      delete frame.context_line;
      if (frame.filename?.includes("://")) frame.filename = safeUrl(frame.filename);
      if (frame.abs_path?.includes("://")) frame.abs_path = safeUrl(frame.abs_path);
    }
  }
  if (event.request) {
    event.request = { method: event.request.method, url: safeUrl(event.request.url) };
  }
  if (event.transaction) {
    event.transaction = event.transaction.replace(/\S*\/\S*/g, (url) => safeUrl(url));
  }
  const trace = event.contexts?.trace;
  event.contexts = trace ? { trace: {
    trace_id: trace.trace_id, span_id: trace.span_id,
    parent_span_id: trace.parent_span_id, op: trace.op, status: trace.status,
  } } : {};
  const allowedTags = new Set(["source", "task", "socket_event", "game_mode", "phase", "player_count", "platform"]);
  event.tags = Object.fromEntries(Object.entries(event.tags || {}).filter(([key]) => allowedTags.has(key)));
  for (const span of event.spans || []) {
    // SQL, outgoing URLs, and span attributes can contain private data.
    span.description = span.op || "operation";
    span.data = {};
  }
  return event;
}
